import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Disable the browser's automatic scroll restoration so the previous
// page's scroll position is never reapplied.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// Scrolls the window to the top:
//   1. Immediately when an internal link is clicked (before React Router renders the
//      new route) — this prevents the "flash of bottom" caused by the new page
//      inheriting the old page's scroll position.
//   2. After every route change as a safety net.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const handler = (e) => {
      // Find the nearest anchor that was actually clicked.
      const link = e.target.closest && e.target.closest("a[href]");
      if (!link) return;
      // Same-origin, no target=_blank, no modifier keys, left click only
      const href = link.getAttribute("href") || "";
      const isInternal = href.startsWith("/") && !href.startsWith("//");
      const newTab = link.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0;
      if (isInternal && !newTab) {
        // Snap to the very top before the route change so the new page
        // never shows its bottom briefly.
        window.scrollTo(0, 0);
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
